export default __webpack_public_path__ + "static/media/mint.312082c7.gif";